webpackJsonp([70144966829960],{

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _StyledComponents = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _StyledComponents.PageIntro,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Contact'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can also reach me on Twitter: ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://twitter.com/jbhuer' },
	          '@jbhuer'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _StyledComponents.Form,
	      { acceptCharset: 'UTF-8', action: 'https://usebasin.com/f/78d6849a1190', method: 'POST' },
	      _react2.default.createElement(
	        _StyledComponents.FormGroup,
	        null,
	        _react2.default.createElement(
	          _StyledComponents.FormLabel,
	          { htmlFor: 'name' },
	          'Name'
	        ),
	        _react2.default.createElement(_StyledComponents.FormInput, { type: 'text', className: 'form-control', id: 'name', name: 'name', required: 'true' })
	      ),
	      _react2.default.createElement(
	        _StyledComponents.FormGroup,
	        null,
	        _react2.default.createElement(
	          _StyledComponents.FormLabel,
	          { htmlFor: 'email' },
	          'Email'
	        ),
	        _react2.default.createElement(_StyledComponents.FormInput, { type: 'email', className: 'form-control', id: 'email', name: 'email', required: 'true' })
	      ),
	      _react2.default.createElement(
	        _StyledComponents.FormGroup,
	        null,
	        _react2.default.createElement(
	          _StyledComponents.FormLabel,
	          { htmlFor: 'message' },
	          'Message'
	        ),
	        _react2.default.createElement(_StyledComponents.FormTextArea, { className: 'form-control', id: 'message', rows: '3', name: 'message' })
	      ),
	      _react2.default.createElement(
	        _StyledComponents.FormSubmit,
	        { type: 'submit', className: 'btn btn-primary' },
	        'Submit \u2192'
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-e3831d57f3db35a5e5d0.js